import React from "react";
import ReactModal from "react-modal";
import { Formik } from "formik";
import { Card, Col, Form } from "react-bootstrap";
import * as yup from "yup";
import Cleave from "cleave.js/react";
import SelectDropDown from "../../shared/drop-down/drop-down";
import { AddBranchToOffice, UpdateBranch } from "../../../api";
const schema = yup.object({
    branch_name: yup.string().trim().required("* Branch name is required"),
    office_id: yup.number().required("* Office is required"),
});
class AddBranchModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isEdit: props.selectedBranch ? true : false,
            is_submitted: false,
            officeOptions: this.generateOfficeOptions(props.officesList),
            formData: {
                branch_name: props.selectedBranch
                    ? props.selectedBranch.name
                    : "",
                branch_id: props.selectedBranch ? props.selectedBranch.id : "",
                office_id: props.selectedBranch
                    ? props.selectedBranch.office_id
                    : "",
                organization_id: props.organization_id
                    ? props.organization_id
                    : "",
            },
            errors: [],
        };
        this.handleBranchList = this.handleBranchList.bind(this);
        this.updateChange = this.updateChange.bind(this);
        this.handleOfficeChange = this.handleOfficeChange.bind(this);
    }

    generateOfficeOptions(offices) {
        let options = [];
        offices.forEach((office) => {
            options.push({
                value: office.id,
                label: office.name,
            });
        });
        return options;
    }

    handleBranchList(evt) {
        let formData = this.state.formData;
        formData["stratus"] = true;
        const office_id = formData["office_id"];
        if (this.state.isEdit) {
            formData["id"] = this.props.selectedBranch.id;
            UpdateBranch(office_id, formData)
                .then((response) => {
                    if (response.success) {
                        this.props.addNewBranch(response.branches);
                    } else {
                        alert(response.message);
                    }
                })
                .catch((error) => console.log(error));
        } else {
            formData["stratus"] = true;
            AddBranchToOffice(office_id, formData)
                .then((response) => {
                    if (response.success) {
                        this.props.addNewBranch(response.branches);
                    } else {
                        if (response.errors) {
                            let errorMessage = "";
                            Object.entries(response.errors).forEach(
                                ([key, value]) => {
                                    errorMessage =
                                        errorMessage === ""
                                            ? response.errors[key][0]
                                            : errorMessage +
                                              "\n" +
                                              response.errors[key][0];
                                },
                            );
                            alert(errorMessage);
                        } else {
                            alert(response.message);
                        }
                    }
                })
                .catch((error) => console.log(error));
        }
    }

    updateChange(event) {
        const targetName = event.target.name;
        if (targetName === "") {
            return false;
        }
        let formData = this.state.formData;
        formData[targetName] = event.target.value.trim();
        this.setState({ formData: formData });
    }

    handleOfficeChange(event) {
        let formData = this.state.formData;
        formData["office_id"] = event.value;
        this.setState({ formData: formData });
    }

    render() {
        const { is_submitted, formData, errors, isEdit, officeOptions } =
            this.state;
        return (
            <ReactModal
                isOpen={this.props.show}
                className="add-residue-modal Add-residual add-member-modal"
            >
                <div
                    onClick={() => this.props.handleClose()}
                    className="modal-cancel"
                >
                    <img src="/images/cancel.svg" />
                </div>
                <div className="modal-header">
                    <h4 className="text-left">
                        {isEdit ? "Edit branch" : "Add Branch"}
                    </h4>
                </div>
                <div className="modal-body">
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(e) => this.handleBranchList(e)}
                        initialValues={formData}
                        initialErrors={errors}
                        validateOnBlur={false}
                        validateOnChange={is_submitted}
                        validate={(values) => {
                            this.setState({ is_submitted: true });
                        }}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values,
                            touched,
                            errors,
                        }) => (
                            <Form
                                onSubmit={handleSubmit}
                                onChange={(e) => this.updateChange(e)}
                                autoComplete="off"
                            >
                                <Form.Row>
                                    <Form.Group
                                        className="px-3 modal-pd"
                                        as={Col}
                                        xs={12}
                                        lg={6}
                                        controlId="office_id"
                                    >
                                        <SelectDropDown
                                            options={officeOptions}
                                            name="office_id"
                                            placeholder="Select Office"
                                            value={values.office_id}
                                            handleChange={(selected) => {
                                                values.office_id =
                                                    selected.value;
                                                this.handleOfficeChange(
                                                    selected,
                                                );
                                                errors.office_id = "";
                                            }}
                                            touched={touched.office_id}
                                            errors={errors.office_id}
                                            is_submitted={is_submitted}
                                        />
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.office_id}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <Form.Control
                                            placeholder="Branch Name"
                                            type="text"
                                            name="branch_name"
                                            value={values.branch_name}
                                            onChange={handleChange}
                                            isInvalid={
                                                touched.branch_name &&
                                                !!errors.branch_name
                                            }
                                            isValid={
                                                is_submitted &&
                                                !errors.branch_name
                                            }
                                            className="preapp-form-input"
                                        />

                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.branch_name}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Form.Row>
                                <div className="modal-footer">
                                    <button
                                        type="submit"
                                        className="btn confirm-button"
                                    >
                                        {isEdit ? "Update" : "Add"}
                                    </button>
                                    <button
                                        className="btn cancel-button"
                                        onClick={() => this.props.handleClose()}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </ReactModal>
        );
    }
}

export default AddBranchModal;
